import { Moon } from "lucide-react";
import { OFFER_URL, PRIVACY_URL } from "@/lib/site";

export const Footer = () => {
  return (
    <footer className="border-t border-[#D4AF6E]/15 bg-[#0a0a1a] py-12" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm text-center md:text-left">
            <div className="flex items-center justify-center gap-2.5 md:justify-start">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF6E]/40 bg-[#111133]">
                <Moon className="h-4 w-4 text-[#F0C674]" />
              </span>
              <span className="font-serif text-xl font-semibold text-[#EDE6D3]">
                Бабушка Варвара
              </span>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-[#EDE6D3]/45">
              <span
                className="mr-2 inline-flex items-center justify-center rounded-full border border-[#D4AF6E]/40 text-[#F0C674]"
                style={{ width: 34, height: 34, fontSize: 11, fontWeight: 700, verticalAlign: "middle" }}
                aria-label="18 плюс"
              >
                18+
              </span>
              Развлекательный формат. Разборы создаёт искусственный интеллект в образе персонажа.
              Не является медицинской, юридической, финансовой или психологической консультацией.
              Услуги предоставляются лицам старше 18 лет.
            </p>
            <p className="mt-3 text-xs leading-relaxed text-[#EDE6D3]/45">
              Самозанятый Садков Е. А., ИНН 732894935375. Вопросы, претензии и возвраты:{" "}
              <a href="mailto:mmski2002@gmail.com" className="text-[#EDE6D3]/70 hover:text-[#F0C674]">
                mmski2002@gmail.com
              </a>
            </p>
          </div>

          <nav className="flex flex-col items-center gap-3 text-sm md:items-end">
            <a
              href={OFFER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EDE6D3]/70 transition-colors hover:text-[#F0C674]"
              data-testid="footer-offer-link"
            >
              Публичная оферта
            </a>
            <a
              href={PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EDE6D3]/70 transition-colors hover:text-[#F0C674]"
              data-testid="footer-privacy-link"
            >
              Политика конфиденциальности
            </a>
          </nav>
        </div>

        <div className="mt-10 border-t border-[#D4AF6E]/10 pt-6 text-center text-xs text-[#EDE6D3]/40">
          © {new Date().getFullYear()} Бабушка Варвара. Все права защищены.
        </div>
      </div>
    </footer>
  );
};
